import { Typography } from '@components/base';
import css from './index.module.scss';
import { IFilteredValue, IRemarks } from '../../../orderOverview';
import { formatRemarksForDisplay } from '@helpers/utils';

interface IRemarkProps {
  previewData: {
    remarks: IRemarks;
    dataSource?: 'v1' | 'v2';
  };
  filteredValue?: IFilteredValue;
}

const Remarks = (props: IRemarkProps) => {
  const { previewData, filteredValue } = props;
  const { remarks, dataSource } = previewData;
  console.log(remarks, 'remarks', dataSource, 'dataSource');
  const piRemarks = remarks?.piRemarks
    ? dataSource === 'v1'
      ? JSON?.parse(remarks?.piRemarks).string
      : formatRemarksForDisplay(remarks?.piRemarks as any)
    : '';
  const ciRemarks = remarks?.ciRemarks
    ? dataSource === 'v1'
      ? remarks?.ciRemarks
      : formatRemarksForDisplay(remarks?.ciRemarks as any)
    : '';

  const customerAdditionalRemarks = remarks?.customerAdditionalRemarks
    ? dataSource === 'v1'
      ? remarks?.customerAdditionalRemarks
      : formatRemarksForDisplay(remarks?.customerAdditionalRemarks as any)
    : '';
  console.log(piRemarks, 'piRemarks', ciRemarks, 'ciRemarks');
  const addAdditionalClass = (key: string) => {
    return filteredValue?.key == key ? css.filtered : '';
  };

  return (
    <div className={css.detailWrapper}>
      <div className={css.detailsTitle}>
        <Typography variant="h4">Remarks</Typography>
      </div>
      <div className={css.detailContainer}>
        <div className={css.rowWrapper}>
          <div className={`${css.fieldWrapper} ${addAdditionalClass('customerAdditionalRemarks')}`}>
            <Typography
              variant="label"
              className={`${css.fieldLabel} ${addAdditionalClass('customerAdditionalRemarks')}`}
            >
              Customer Additional Remarks
            </Typography>
            <div className={css.fieldValueContainer}>
              {customerAdditionalRemarks ? (
                <Typography
                  variant="body"
                  className={`${addAdditionalClass('customerAdditionalRemarks')}`}
                >
                  {customerAdditionalRemarks}
                </Typography>
              ) : (
                <Typography
                  variant="label"
                  className={`${css.notAvailable} ${addAdditionalClass(
                    'customerAdditionalRemarks'
                  )}`}
                >
                  Not Available
                </Typography>
              )}
            </div>
          </div>
        </div>
        <div className={css.rowWrapper}>
          <div className={`${css.fieldWrapper} ${addAdditionalClass('ciRemarks')}`}>
            <Typography
              variant="label"
              className={`${css.fieldLabel} ${addAdditionalClass('ciRemarks')}`}
            >
              CI Remarks
            </Typography>
            <div className={css.fieldValueContainer}>
              {ciRemarks ? (
                <Typography variant="body" className={` ${addAdditionalClass('ciRemarks')}`}>
                  {ciRemarks}
                </Typography>
              ) : (
                <Typography
                  variant="label"
                  className={`${css.notAvailable} ${addAdditionalClass('ciRemarks')}`}
                >
                  Not Available
                </Typography>
              )}
            </div>
          </div>
        </div>
        <div className={css.rowWrapper}>
          <div className={`${css.fieldWrapper} ${addAdditionalClass('piRemarks')}`}>
            <Typography
              variant="label"
              className={`${css.fieldLabel} ${addAdditionalClass('piRemarks')}`}
            >
              PI Remarks
            </Typography>
            <div className={css.fieldValueContainer}>
              {piRemarks ? (
                <Typography variant="body" className={`${addAdditionalClass('piRemarks')}`}>
                  {piRemarks}
                </Typography>
              ) : (
                <Typography
                  variant="label"
                  className={`${css.notAvailable} ${addAdditionalClass('piRemarks')}`}
                >
                  Not Available
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Remarks;
